import { render, staticRenderFns } from "./ReembolsoDevolucao.vue?vue&type=template&id=145e4973&"
import script from "./ReembolsoDevolucao.vue?vue&type=script&lang=js&"
export * from "./ReembolsoDevolucao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports